import { _convertDateTimeToTimestamp } from '@fabric/components/private/utilities';

/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const isPresent = (value) => value !== null && value !== undefined;
const isBlank = (value) => value === null || value === undefined;
const operatorsMap = {
    contains: (a, b) => (a ?? '').indexOf(b) >= 0,
    doesnotcontain: (a, b) => (a ?? '').indexOf(b) === -1,
    endswith: (a, b) => (a ?? '').indexOf(b, (a ?? '').length - (b ?? '').length) >= 0,
    eq: (a, b) => a === b,
    gt: (a, b) => a > b,
    gte: (a, b) => a >= b,
    isempty: (a) => a === '' || isBlank(a),
    isnotempty: (a) => a !== '' && isPresent(a),
    lt: (a, b) => a < b,
    lte: (a, b) => a <= b,
    neq: (a, b) => a !== b,
    startswith: (a, b) => (a ?? '').lastIndexOf(b, 0) === 0,
};
/**
 * compiles a readable array of filter objects
 * @param event - filter object passed into the function inside an array
 * @param container - currently used filter objects in an array
 * @returns array of filter objects
 */
function filterStateChange(event, container) {
    if (event[0].operator === 'clear') {
        container = container.filter((item) => item.field !== event[0].field);
    }
    else {
        container = container.concat(event);
        if (container.length > 0) {
            // element : The current element being processed in the array
            // index : The index of the current element being processed in the array
            // array: The array for which the filter was called upon
            // findIndex method returns the index of the first element in the array that satisfies the provided testing function.
            container = container
                .concat(event)
                .slice()
                .reverse()
                .filter((element, index, array) => array.findIndex((item) => item.field === element.field) === index)
                .reverse();
        }
    }
    return container;
}
/**
 * process filters through the data passed
 * @param data - table data
 * @param state - current state of the data table, includes skip, take, filter and sort
 * @returns data that is filtered based on the state
 */
function process(data, state) {
    state.filter.forEach((filter) => {
        data = data.filter(transformFilter(filter));
    });
    return data;
}
/**
 * transform filter object into a filter function based on the operator provided
 * lower case the string value for better match making
 * @param filterObject  - filter object which includes field, value and operator
 * @returns filter function
 */
function transformFilter(filterObject) {
    const field = filterObject.field;
    const value = filterObject.value;
    const operator = filterObject.operator;
    const operatorFunction = operatorsMap[operator];
    return function (item) {
        if (typeof item[field] === 'string' && value) {
            return operatorFunction(item[field].toLowerCase(), value.toLowerCase());
        }
        if (item[field] instanceof Date && value) {
            return operatorFunction(_convertDateTimeToTimestamp(item[field]), _convertDateTimeToTimestamp(value));
        }
        return operatorFunction(item[field], value);
    };
}

/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { filterStateChange, process };
